import { render } from "./WorkingGroup.vue?vue&type=template&id=5c0f06b8&scoped=true"
import script from "./WorkingGroup.vue?vue&type=script&lang=js"
export * from "./WorkingGroup.vue?vue&type=script&lang=js"

import "./WorkingGroup.vue?vue&type=style&index=0&id=5c0f06b8&scoped=true&lang=css"
import "./WorkingGroup.vue?vue&type=style&index=1&id=5c0f06b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c0f06b8"]])

export default __exports__